<template lang='pug'>
.newsletter-signups
  .box.mt-4
    b-table(
      :fields='fields'
      :items='signupsProvider'
      :per-page='rowsPerPage'
      :current-page='currentPage'
      hover
      striped
      small
      responsive
    )
      template(v-slot:cell(date)='data')
        | {{ formatDate(data.value) }}
      template(v-slot:cell(utm)='data')
        UtmPopup(
          :rowId='data.item.id'
          :utmTags='data.item'
        )
    b-pagination(
      align='center'
      :total-rows='totalRows'
      :per-page='rowsPerPage'
      v-model='currentPage'
    )
</template>

<script>
import { authBackend, formatDate } from '../api'
import UtmPopup from '../components/UtmPopup.vue'

const rowsPerPage = 20
const fields = [
  { key: 'firstName',
    label: 'Eesnimi'
  },
  { key: 'lastName',
    label: 'Perekonnanimi'
  },
  { key: 'email',
    label: 'E-post'
  },
  { key: 'phone',
    label: 'Telefon'
  },
  { key: 'newsletter',
    label: 'Uudiskiri'
  },
  { key: 'date',
    label: 'Kuupäev'
  },
  {
    key: 'utm',
    label: 'UTM'
  }
]

export default {
  name: 'newsletter-signups',

  components: { UtmPopup },

  data() {
    return {
      fields,
      currentPage: 1,
      rowsPerPage,
      totalRows: 0
    }
  },

  methods: {
    formatDate,

    async fetchSignups() {
      const signups = (
        await authBackend().get('/api/smaily/signup', {
          params: {
            page: this.currentPage - 1
          }
        })
      ).data
      this.totalRows = signups.totalRows
      return signups.signups
    },

    signupsProvider(_ctx, callback) {
      this.fetchSignups().then(callback)
    }
  }
}
</script>
